import axios from 'axios';
import { unsafeSend } from './messages';
import { ErrorTracking } from '../config';
import { safeStringify } from './safe-stringify';

export const ANALYTICS_EVENTS = {
  /**
   * form field initialized
   */
  INIT: 'Init',
  /**
   * triggered from SDK when a form field failed to init
   */
  FIELD_INIT_SDK: 'InitSDK',
  /**
   * event is triggered by the parent window when `form.submit` method is called
   */
  SUBMIT_CALLED_SDK: 'SubmitCalledSDK',
  /**
   * event is triggered before making ajax request
   */
  BEFORE_SUBMIT: 'BeforeSubmit',
  /**
   * submit ajax request is resolved or rejected
   */
  SUBMIT: 'Submit',
  /**
   * submit event is received by parent window and sent back to the iframe
   */
  RECEIVE_SUBMIT: 'ReceiveSubmit',
  /**
   * event is triggered when the client submit callback throws an error
   */
  SUBMIT_CALLBACK_ERROR: 'SubmitCallbackError',
  /**
   * event is triggered once callback received by parent window
   * and before returning the response to the client's app
   */
  BEFORE_SUBMIT_CALLBACK: 'BeforeSubmitCallback',
  /**
   * event is triggered once callback received by parent window
   * and after thecallback was returned to the client's app
   */
  AFTER_SUBMIT_CALLBACK: 'AfterSubmitCallback',
  /**
   * event is triggered when a post message from an iframe to the parent window is sent or failed sending
   */
  POST_MESSAGE: 'PostMessage',
  /**
   * event is triggered when a callback timeout received
   */
  CALLBACK_TIMEOUT: 'CallbackTimeout',
  /**
   * event is triggered from client window after submit timeout
   */
  CALLBACK_TIMEOUT_SDK: 'CallbackTimeoutSDK',
};

export const getInternetSpeed = () => {
  if ('navigator' in window && window.navigator.connection) {
    return navigator.connection.downlink;
  }
  return undefined;
};

const url = `${LINK_TO_KEEPER}/vgs`;

export const sendAnalyticsEvent = (rawData) => {
  const { logLevel } = window.globalConfig;

  if(!window.telemetryMain) {
    if (!window.telemetry) window.telemetry = [];
    window.telemetry.push(rawData);
    return Promise.resolve();
  }

  if (NODE_ENV === 'development' || logLevel === 'none') {
    return Promise.resolve(false);
  }

  let ecryptedData = null;
  try {
    ecryptedData = window.btoa(unescape(encodeURIComponent(JSON.stringify(rawData))));
  } catch (err) {
    ErrorTracking.info('Unable to encrypt analytics data', err, {
      analyticsData: safeStringify(rawData),
    });
  }
  return axios({
    method: 'POST',
    url,
    data: ecryptedData,
  });
};

const trackEvent = (analyticsData) => {
  const { vgsCollectSessionId, formId, env, tnt, type, fieldId, logLevel } = window.globalConfig;
  if (NODE_ENV === 'development' || logLevel === 'none') {
    return false;
  }

  const internetSpeed = getInternetSpeed();

  const data = {
    formId,
    fieldId,
    env: window.atob(env),
    tnt: window.atob(tnt),
    version: LIB_VERSION,
    userAgent: window.navigator.userAgent,
    field: type,
    timestamp: Date.now(),
    ...(typeof internetSpeed === 'number' ? { internetSpeed } : null),
    ...(vgsCollectSessionId ? { vgsCollectSessionId } : null),
  };

  const rawData = {
    ...analyticsData,
    ...data,
  };

  unsafeSend(window.parent, 'trackAnalyticsEvent', {
    formId,
    payload: rawData,
  });

  sendAnalyticsEvent(rawData).catch((e) => {});
};

export default trackEvent;
